import React, { useState, useEffect, useRef, useCallback } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import {
  FiUser,
  FiPhone,
  FiArrowRight,
  FiChevronLeft,
  FiStar,
  FiCheck,
  FiInfo,
  FiCopy,
  FiCheckCircle,
  FiClock,
  FiScissors,
  FiAlertCircle,
  FiX,
  FiLoader,
  FiCalendar,
} from "react-icons/fi";
import {
  usersAPI,
  workScheduleAPI,
  appointmentsAPI,
  api,
} from "services/api";
import { useAuth } from "context/AuthContext";

// ============================================================
// YARDIMCI FONKSİYONLAR
// ============================================================
const getInitials = (name) => {
  if (!name) return "?";
  const parts = name.split(" ");
  if (parts.length === 1 && parts[0].length > 1)
    return parts[0].substring(0, 2).toUpperCase();
  return (
    (parts[0][0] || "") + (parts[parts.length - 1][0] || "")
  ).toUpperCase();
};

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const timeToMinutes = (timeStr) => {
  if (!timeStr) return 0;
  const [hours, minutes] = timeStr.split(":").map(Number);
  return hours * 60 + minutes;
};

const transformWorkDaysToSchedule = (workDays = []) => {
  const schedule = {};
  workDays.forEach((day) => {
    if (day.is_active)
      schedule[day.day_of_week] = { start: day.start_time, end: day.end_time };
  });
  return schedule;
};

// ============================================================
// LOGO/MARKA BILEŞENI
// ============================================================
const BrandMark = () => (
  <div className="px-4 pb-4 pt-8 text-center">
    <h1
      style={{
        fontFamily: "'Cormorant Garamond', Georgia, serif",
        letterSpacing: "3px",
        fontSize: "1.9rem",
        fontWeight: 600,
        fontStyle: "italic",
        color: "#ebebeb",
        marginBottom: "2px",
        lineHeight: 1.1,
      }}
    >
      Mudamu
    </h1>
    <div
      style={{
        letterSpacing: "5px",
        fontSize: "0.62rem",
        color: "#787878",
        textTransform: "uppercase",
        fontFamily: "'Outfit', sans-serif",
      }}
    >
      Kuafor
    </div>
  </div>
);

// ============================================================
// PROGRESS BAR
// ============================================================
const WizardProgress = ({ step, total = 5 }) => {
  const pct = ((step - 1) / (total - 1)) * 100;
  return (
    <div className="mb-2 px-6">
      <div
        style={{
          height: "2px",
          background: "rgba(176,176,176,0.12)",
          borderRadius: "99px",
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${pct}%`,
            background: "#b0b0b0",
            borderRadius: "99px",
            transition: "width 0.45s cubic-bezier(.4,0,.2,1)",
          }}
        />
      </div>
      <div className="mt-1.5 flex justify-between">
        {["Giriş", "Uzman", "Hizmet", "Tarih & Saat", "Onay"].map(
          (label, i) => (
            <span
              key={i}
              style={{
                fontSize: "0.58rem",
                letterSpacing: "0.5px",
                textTransform: "uppercase",
                color: i < step ? "#b0b0b0" : "#484848",
                fontFamily: "'Outfit', sans-serif",
                fontWeight: i + 1 === step ? 700 : 400,
                transition: "color 0.3s",
              }}
            >
              {label}
            </span>
          )
        )}
      </div>
    </div>
  );
};

// ============================================================
// HATA MESAJI
// ============================================================
const ErrorBanner = ({ msg, onClose }) => {
  if (!msg) return null;
  return (
    <div
      style={{
        background: "rgba(239,68,68,0.1)",
        border: "1px solid rgba(239,68,68,0.3)",
        borderRadius: "6px",
        padding: "12px 14px",
        marginBottom: "16px",
        display: "flex",
        alignItems: "flex-start",
        gap: "10px",
        fontFamily: "'Outfit', sans-serif",
      }}
    >
      <FiAlertCircle
        size={16}
        style={{ color: "#ef4444", marginTop: "1px", flexShrink: 0 }}
      />
      <span style={{ color: "#fca5a5", fontSize: "0.85rem", flex: 1 }}>
        {msg}
      </span>
      {onClose && (
        <button
          onClick={onClose}
          style={{
            background: "none",
            border: "none",
            color: "#787878",
            cursor: "pointer",
            padding: 0,
          }}
        >
          <FiX size={14} />
        </button>
      )}
    </div>
  );
};

// ============================================================
// ANA BUTON
// ============================================================
const LuxuryBtn = ({
  children,
  onClick,
  disabled,
  type = "button",
  style: extStyle = {},
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    style={{
      width: "100%",
      padding: "15px 20px",
      background: disabled ? "#242424" : "#b0b0b0",
      color: disabled ? "#484848" : "#0a0a0a",
      border: "none",
      borderRadius: "4px",
      fontFamily: "'Outfit', sans-serif",
      fontWeight: 700,
      fontSize: "0.78rem",
      letterSpacing: "2.5px",
      textTransform: "uppercase",
      cursor: disabled ? "not-allowed" : "pointer",
      transition: "all 0.25s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
      boxShadow: disabled ? "none" : "0 4px 20px rgba(176,176,176,0.15)",
      ...extStyle,
    }}
    onMouseEnter={(e) => {
      if (!disabled) e.currentTarget.style.transform = "translateY(-2px)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
    }}
  >
    {children}
  </button>
);

// ============================================================
// GERİ BUTONU
// ============================================================
const BackBtn = ({ onClick, label }) => (
  <button
    onClick={onClick}
    style={{
      background: "none",
      border: "none",
      color: "#b0b0b0",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "6px",
      fontSize: "0.75rem",
      letterSpacing: "1px",
      textTransform: "uppercase",
      fontFamily: "'Outfit', sans-serif",
      fontWeight: 600,
      padding: 0,
      marginBottom: "20px",
    }}
  >
    <FiChevronLeft size={16} /> {label}
  </button>
);

// ============================================================
// STEP LABEL
// ============================================================
const StepLabel = ({ num, label }) => (
  <p
    style={{
      fontSize: "0.65rem",
      letterSpacing: "2px",
      textTransform: "uppercase",
      color: "#787878",
      fontFamily: "'Outfit', sans-serif",
      fontWeight: 600,
      marginBottom: "16px",
    }}
  >
    {num}. {label}
  </p>
);

// ============================================================
// STAFF KART
// ============================================================
const StaffCard = ({ staff, onClick }) => (
  <div
    onClick={onClick}
    style={{
      background: "#1c1c1c",
      border: "1px solid rgba(176,176,176,0.1)",
      borderRadius: "4px",
      padding: "14px 16px",
      marginBottom: "10px",
      display: "flex",
      alignItems: "center",
      gap: "14px",
      cursor: "pointer",
      transition: "all 0.25s ease",
      boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.borderColor = "rgba(176,176,176,0.35)";
      e.currentTarget.style.background = "rgba(176,176,176,0.04)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.borderColor = "rgba(176,176,176,0.1)";
      e.currentTarget.style.background = "#1c1c1c";
    }}
    onTouchStart={(e) => {
      e.currentTarget.style.transform = "scale(0.98)";
    }}
    onTouchEnd={(e) => {
      e.currentTarget.style.transform = "scale(1)";
    }}
  >
    {/* Avatar */}
    {staff.picture ? (
      <img
        src={staff.picture}
        alt={staff.name}
        style={{
          width: 50,
          height: 50,
          borderRadius: "50%",
          border: "1px solid #b0b0b0",
          objectFit: "cover",
          flexShrink: 0,
        }}
      />
    ) : (
      <div
        style={{
          width: 50,
          height: 50,
          borderRadius: "50%",
          border: "1px solid #b0b0b0",
          background: "rgba(176,176,176,0.05)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#b0b0b0",
          fontWeight: 700,
          fontSize: "1rem",
          flexShrink: 0,
          fontFamily: "'Outfit', sans-serif",
        }}
      >
        {getInitials(staff.name)}
      </div>
    )}

    {/* Bilgi */}
    <div style={{ flex: 1, minWidth: 0 }}>
      <div
        style={{
          color: "#ebebeb",
          fontWeight: 600,
          fontSize: "0.95rem",
          fontFamily: "'Outfit', sans-serif",
        }}
      >
        {staff.name} {staff.surname}
      </div>
      <div
        style={{
          color: "#787878",
          fontSize: "0.75rem",
          marginTop: "2px",
          fontFamily: "'Outfit', sans-serif",
        }}
      >
        {staff.tag || "Saç Tasarım Uzmanı"}
      </div>
    </div>

    {/* Rating + Ok */}
    <div style={{ textAlign: "right", flexShrink: 0 }}>
      {staff.rating && (
        <div
          style={{
            color: "#b8b8b8",
            fontSize: "0.75rem",
            marginBottom: "4px",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            justifyContent: "flex-end",
          }}
        >
          <FiStar size={12} style={{ color: "#f59e0b" }} />
          {staff.rating}
        </div>
      )}
      <FiArrowRight size={15} style={{ color: "#484848" }} />
    </div>
  </div>
);

// ============================================================
// HİZMET KART
// ============================================================
const ServiceCard = ({ service, selected, onClick }) => (
  <div
    onClick={onClick}
    style={{
      background: selected ? "rgba(176,176,176,0.07)" : "#1c1c1c",
      border: `1px solid ${selected ? "#b0b0b0" : "rgba(176,176,176,0.1)"}`,
      borderRadius: "4px",
      padding: "14px 16px",
      marginBottom: "10px",
      cursor: "pointer",
      transition: "all 0.25s ease",
      boxShadow: selected
        ? "0 8px 20px rgba(0,0,0,0.5)"
        : "0 4px 15px rgba(0,0,0,0.3)",
    }}
    onTouchStart={(e) => {
      e.currentTarget.style.transform = "scale(0.98)";
    }}
    onTouchEnd={(e) => {
      e.currentTarget.style.transform = "scale(1)";
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "6px",
      }}
    >
      <span
        style={{
          color: selected ? "#b0b0b0" : "#ebebeb",
          fontWeight: 600,
          fontSize: "0.95rem",
          fontFamily: "'Outfit', sans-serif",
        }}
      >
        {service.name}
      </span>
      <span
        style={{
          color: "#ebebeb",
          fontWeight: 700,
          fontSize: "0.9rem",
          fontFamily: "'Outfit', sans-serif",
        }}
      >
        {service.price}₺
      </span>
    </div>
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <span
        style={{
          color: "#787878",
          fontSize: "0.73rem",
          fontFamily: "'Outfit', sans-serif",
        }}
      >
        {service.description || "Standart İşlem"}
      </span>
      <span
        style={{
          color: "#787878",
          fontSize: "0.73rem",
          fontFamily: "'Outfit', sans-serif",
        }}
      >
        {service.duration} dk
      </span>
    </div>
    {selected && (
      <div
        style={{
          marginTop: "8px",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          color: "#b0b0b0",
        }}
      >
        <FiCheckCircle size={12} />
        <span
          style={{
            fontSize: "0.7rem",
            fontFamily: "'Outfit', sans-serif",
            letterSpacing: "1px",
          }}
        >
          SEÇİLDİ
        </span>
      </div>
    )}
  </div>
);

// ============================================================
// SAAT SLOT
// ============================================================
const TimeSlot = ({ slot, selected, onClick }) => {
  const baseStyle = {
    border: "1px solid rgba(176,176,176,0.2)",
    borderRadius: "4px",
    padding: "12px 6px",
    textAlign: "center",
    fontSize: "0.85rem",
    fontFamily: "'Outfit', sans-serif",
    fontWeight: 500,
    transition: "all 0.2s ease",
    cursor: slot.isAvailable && !slot.isGhost ? "pointer" : "not-allowed",
    userSelect: "none",
    letterSpacing: "0.5px",
  };

  if (selected) {
    return (
      <div
        style={{
          ...baseStyle,
          background: "#b0b0b0",
          color: "#0a0a0a",
          borderColor: "#b0b0b0",
          fontWeight: 700,
        }}
      >
        {slot.time}
      </div>
    );
  }
  if (slot.isGhost) {
    return (
      <div
        title="Bu saat dolu veya kaydırılmış"
        style={{
          ...baseStyle,
          opacity: 0.5,
          textDecoration: "line-through",
          background: "rgba(255,0,0,0.05)",
          color: "#787878",
          border: "1px dashed #484848",
        }}
      >
        {slot.time}
      </div>
    );
  }
  if (!slot.isAvailable) {
    return (
      <div
        style={{
          ...baseStyle,
          opacity: 0.2,
          textDecoration: "line-through",
          borderColor: "transparent",
          color: "#787878",
        }}
      >
        {slot.time}
      </div>
    );
  }
  return (
    <div
      onClick={onClick}
      style={{ ...baseStyle, background: "#242424", color: "#ebebeb" }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "rgba(176,176,176,0.12)";
        e.currentTarget.style.color = "#b0b0b0";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "#242424";
        e.currentTarget.style.color = "#ebebeb";
      }}
    >
      {slot.time}
    </div>
  );
};

// ============================================================
// ANA WIZARD BILEŞENI
// ============================================================
const FastBooking = () => {
  const { login } = useAuth();
  const nextButtonRef = useRef(null);

  // State
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isTimeLoading, setIsTimeLoading] = useState(false);
  const [isServicesLoading, setIsServicesLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const [userInfo, setUserInfo] = useState({
    name: "",
    surname: "",
    phone: "",
  });
  const [authenticatedUser, setAuthenticatedUser] = useState(null);
  const [staffList, setStaffList] = useState([]);

  const [mainServices, setMainServices] = useState([]);
  const [optionalServices, setOptionalServices] = useState([]);
  const [genderFilter, setGenderFilter] = useState("all");

  const [selectedStaff, setSelectedStaff] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedOptionalServices, setSelectedOptionalServices] = useState([]);

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [timeSlots, setTimeSlots] = useState([]);
  const [selectedTime, setSelectedTime] = useState(null);
  const [note, setNote] = useState("");

  const maxDateLimit = new Date();
  maxDateLimit.setDate(maxDateLimit.getDate() + 60);

  // ============================================================
  // ADIM 1: GİRİŞ
  // ============================================================
  const handleInfoSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    const cleanPhone = userInfo.phone.replace(/\D/g, "");
    if (cleanPhone.length !== 10 || !cleanPhone.startsWith("5")) {
      setError("Telefon numaranız 5 ile başlamalı ve 10 haneli olmalıdır.");
      setLoading(false);
      return;
    }

    try {
      const payload = {
        name: userInfo.name,
        surname: userInfo.surname,
        phone: "+90" + cleanPhone,
      };
      const response = await api.post("/fast-login", payload);
      const data = response.data || response;

      if (data.token) {
        login(data.user, data.token);
        setAuthenticatedUser(data.user);
        await fetchStaffList();
        setStep(2);
      } else {
        throw new Error("Giriş başarılı ancak jeton alınamadı.");
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Giriş yapılamadı. Bilgilerinizi kontrol ediniz."
      );
    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  // PERSONEL LİSTESİ
  // ============================================================
  const fetchStaffList = async () => {
    try {
      const res = await usersAPI.getStaff();
      const staffData = res.staff || res.data?.staff || [];
      setStaffList(
        staffData.map((s) => ({
          ...s,
          schedule: transformWorkDaysToSchedule(s.workDays || []),
        }))
      );
    } catch {
      setStaffList([]);
    }
  };

  const handleStaffSelect = async (staff) => {
    setSelectedStaff(staff);
    setSelectedService(null);
    setSelectedOptionalServices([]);
    setGenderFilter("all");
    setStep(3);
    setIsServicesLoading(true);
    setError(null);

    try {
      const response = await api.get(`/services?staff_id=${staff.id}`);
      const data = response.data || response;
      if (data.success && data.services) {
        setMainServices(data.services.filter((s) => !s.optional));
        setOptionalServices(data.services.filter((s) => s.optional));
      }
    } catch {
      setError("Bu personelin hizmet bilgileri alınamadı.");
    } finally {
      setIsServicesLoading(false);
    }
  };

  // ============================================================
  // HİZMET SEÇİMİ
  // ============================================================
  const handleServiceSelect = (service) => {
    setSelectedService(service);
    setSelectedOptionalServices([]);
    setTimeout(() => {
      if (nextButtonRef.current) {
        nextButtonRef.current.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }
    }, 150);
  };

  const handleToggleOptionalService = (service) => {
    setSelectedOptionalServices((prev) => {
      const isAlready = prev.some((s) => s.id === service.id);
      if (isAlready) return prev.filter((s) => s.id !== service.id);
      if (prev.length < 2) return [...prev, service];
      setError("En fazla 2 ekstra işlem seçebilirsiniz.");
      setTimeout(() => setError(null), 3000);
      return prev;
    });
  };

  const handleProceedToTime = () => {
    if (selectedService) setStep(4);
  };

  // ============================================================
  // SAAT SLOTLARI — GHOST SLOT + CHAIN CHECK (Birebir Aynı Logic)
  // ============================================================
  useEffect(() => {
    const fetchTimeSlots = async () => {
      if (step !== 4 || !selectedStaff || !selectedService) return;

      setIsTimeLoading(true);
      setTimeSlots([]);
      setError(null);
      setSelectedTime(null);

      try {
        const selectedDateStr = formatDate(selectedDate);
        const response = await workScheduleAPI.getAvailableSlots(
          selectedStaff.id,
          selectedDateStr
        );
        const slotsForDate = response.available_slots?.[selectedDateStr] || [];

        if (slotsForDate.length === 0) {
          setError(`${selectedDateStr} tarihi için randevu doludur.`);
          setIsTimeLoading(false);
          return;
        }

        // Toplam süre hesabı
        let totalDuration = parseInt(selectedService.duration) || 0;
        selectedOptionalServices.forEach((opt) => {
          totalDuration += parseInt(opt.duration) || 0;
        });

        const now = new Date();
        const isTodaySelected =
          selectedDate.toDateString() === now.toDateString();
        const currentTotalMinutes = now.getHours() * 60 + now.getMinutes();

        // Sıralama
        const sortedSlots = [...slotsForDate].sort(
          (a, b) =>
            timeToMinutes(a.start_time || a.time) -
            timeToMinutes(b.start_time || b.time)
        );

        let finalDisplayList = [];

        sortedSlots.forEach((slot, index) => {
          const timeStr = slot.start_time || slot.time;
          if (!timeStr) return;

          const slotStartMinutes = timeToMinutes(timeStr);

          // 1. Ghost Slot Kontrolü
          if (slot.old_time && slot.old_time !== timeStr) {
            const isAlreadyThere = finalDisplayList.some(
              (f) => f.time === slot.old_time.substring(0, 5)
            );
            if (!isAlreadyThere) {
              finalDisplayList.push({
                time: slot.old_time.substring(0, 5),
                isAvailable: false,
                isGhost: true,
                workHourId: `ghost-${slot.id}`,
              });
            }
          }

          // 2. Geçmiş Zaman Kontrolü
          let isPastTime =
            isTodaySelected && slotStartMinutes <= currentTotalMinutes;
          let isSlotAvailable =
            !isPastTime &&
            (slot.is_available == true ||
              slot.is_available === 1 ||
              slot.is_available === "1");

          // 3. Chain Check (Süre Yetiyor mu?)
          if (isSlotAvailable) {
            const requiredEndTime = slotStartMinutes + totalDuration;
            let currentChainTime = slotStartMinutes;
            let chainBroken = false;

            for (let i = index; i < sortedSlots.length; i++) {
              const checkSlot = sortedSlots[i];
              const checkStart = timeToMinutes(
                checkSlot.start_time || checkSlot.time
              );
              const checkEnd = checkSlot.end_time
                ? timeToMinutes(checkSlot.end_time)
                : checkStart + 15;

              if (checkStart > currentChainTime + 1) {
                chainBroken = true;
                break;
              }

              const isCheckAvailable =
                checkSlot.is_available == true ||
                checkSlot.is_available === 1 ||
                checkSlot.is_available === "1";
              if (!isCheckAvailable) {
                chainBroken = true;
                break;
              }

              currentChainTime = checkEnd;
              if (currentChainTime >= requiredEndTime) break;
            }

            if (chainBroken || currentChainTime < requiredEndTime) {
              isSlotAvailable = false;
            }
          }

          finalDisplayList.push({
            time: timeStr.substring(0, 5),
            isAvailable: isSlotAvailable,
            isGhost: false,
            workHourId: slot.id,
          });
        });

        finalDisplayList.sort(
          (a, b) => timeToMinutes(a.time) - timeToMinutes(b.time)
        );
        setTimeSlots(finalDisplayList);

        if (finalDisplayList.filter((s) => s.isAvailable).length === 0) {
          setError("Seçilen işlem süresi için uygun boşluk bulunamadı.");
        }
      } catch {
        setError("Saatler yüklenirken hata oluştu.");
      } finally {
        setIsTimeLoading(false);
      }
    };

    fetchTimeSlots();
  }, [
    selectedDate,
    step,
    selectedService,
    selectedStaff,
    selectedOptionalServices,
  ]);

  // ============================================================
  // TAKVİM - Geçmiş & İzin günleri kapat
  // ============================================================
  const isDayDisabled = ({ date, view }) => {
    if (view !== "month") return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const checkDate = new Date(date);
    checkDate.setHours(0, 0, 0, 0);
    if (checkDate < today) return true;
    if (
      selectedStaff?.schedule &&
      Object.keys(selectedStaff.schedule).length > 0
    ) {
      const dayNames = [
        "Pazar",
        "Pazartesi",
        "Salı",
        "Çarşamba",
        "Perşembe",
        "Cuma",
        "Cumartesi",
      ];
      return !Object.prototype.hasOwnProperty.call(
        selectedStaff.schedule,
        dayNames[date.getDay()]
      );
    }
    return false;
  };

  // ============================================================
  // ADIM 5: RANDEVU ONAYLA
  // ============================================================
  const handleConfirmBooking = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    setError(null);

    try {
      const payload = {
        customer_id: authenticatedUser.id,
        staff_id: selectedStaff.id,
        service_id: selectedService.id,
        optional_service_id_1: selectedOptionalServices[0]?.id || null,
        optional_service_id_2: selectedOptionalServices[1]?.id || null,
        appointment_date: formatDate(selectedDate),
        appointment_time: selectedTime,
        note,
        status: "pending",
      };
      await appointmentsAPI.create(payload);
      setStep(6);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Randevu oluşturulamadı. Lütfen tekrar deneyin."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // Filtered services
  const filteredMainServices = mainServices.filter((service) => {
    if (genderFilter === "all") return true;
    if (genderFilter === "male")
      return (
        service.target_gender === "male" ||
        service.target_gender === "unisex" ||
        !service.target_gender
      );
    if (genderFilter === "female")
      return (
        service.target_gender === "female" ||
        service.target_gender === "unisex" ||
        !service.target_gender
      );
    return true;
  });

  // ============================================================
  // RENDER
  // ============================================================
  return (
    <>
      {/* Fontlar ve Takvim Stilleri */}
      <style>{`
        @import url("https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600&family=Outfit:wght@300;400;500;600;700;800&display=swap");

        .fbw-wrapper {
          min-height: 100vh;
          background: radial-gradient(circle at top, #242424 0%, #0a0a0a 100%);
          display: flex;
          flex-direction: column;
          font-family: 'Outfit', sans-serif;
        }

        .fbw-fade { animation: fbwFadeIn 0.4s ease-out; }
        @keyframes fbwFadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }

        /* TAKVİM */
        .fbw-cal .react-calendar {
          background: #1c1c1c !important;
          border: 1px solid rgba(176,176,176,0.12) !important;
          border-radius: 6px !important;
          width: 100% !important;
          font-family: 'Outfit', sans-serif !important;
          padding: 10px !important;
          color: #ebebeb !important;
        }
        .fbw-cal .react-calendar__navigation button {
          color: #b0b0b0 !important;
          font-size: 0.9rem !important;
          font-weight: 600 !important;
          text-transform: uppercase !important;
          letter-spacing: 1px !important;
          background: none !important;
          border-radius: 4px !important;
        }
        .fbw-cal .react-calendar__navigation button:hover { background: rgba(176,176,176,0.1) !important; }
        .fbw-cal .react-calendar__month-view__weekdays__weekday {
          color: #787878 !important;
          font-weight: 600 !important;
        }
        .fbw-cal .react-calendar__month-view__weekdays__weekday abbr { text-decoration: none !important; }
        .fbw-cal .react-calendar__tile {
          color: #ebebeb !important;
          border-radius: 4px !important;
          height: 44px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          font-family: 'Outfit', sans-serif !important;
          font-size: 0.88rem !important;
          transition: all 0.18s ease !important;
        }
        .fbw-cal .react-calendar__tile:enabled:hover {
          background: rgba(176,176,176,0.12) !important;
          color: #b0b0b0 !important;
        }
        .fbw-cal .react-calendar__tile--active {
          background: #b0b0b0 !important;
          color: #0a0a0a !important;
          font-weight: 700 !important;
        }
        .fbw-cal .react-calendar__tile--now {
          background: transparent !important;
          border: 1px solid #b0b0b0 !important;
          color: #b0b0b0 !important;
        }
        .fbw-cal .react-calendar__tile:disabled { opacity: 0.25 !important; }
        .fbw-cal .react-calendar__navigation__arrow { font-size: 1.2rem !important; }

        /* INPUT */
        .fbw-input {
          width: 100%;
          background: #1c1c1c;
          border: 1px solid rgba(176,176,176,0.18);
          border-radius: 4px;
          padding: 14px 16px;
          color: #ebebeb;
          font-family: 'Outfit', sans-serif;
          font-size: 0.95rem;
          outline: none;
          transition: border-color 0.2s;
          box-sizing: border-box;
        }
        .fbw-input::placeholder { color: #484848; }
        .fbw-input:focus { border-color: rgba(176,176,176,0.5); }

        /* TEXTAREA */
        .fbw-textarea {
          width: 100%;
          background: rgba(176,176,176,0.04);
          border: 1px solid rgba(176,176,176,0.1);
          border-radius: 4px;
          padding: 12px 14px;
          color: #b8b8b8;
          font-family: 'Outfit', sans-serif;
          font-size: 0.85rem;
          outline: none;
          resize: none;
          transition: border-color 0.2s;
          box-sizing: border-box;
        }
        .fbw-textarea::placeholder { color: #484848; }
        .fbw-textarea:focus { border-color: rgba(176,176,176,0.3); }

        /* SLOT GRID */
        .fbw-slot-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 8px;
          margin-bottom: 24px;
        }
        @media (min-width: 400px) {
          .fbw-slot-grid { grid-template-columns: repeat(4, 1fr); }
        }
        @media (min-width: 560px) {
          .fbw-slot-grid { grid-template-columns: repeat(5, 1fr); }
        }

        /* OPSİYONEL BUTONLAR */
        .fbw-opt-btn {
          border-radius: 2px;
          padding: 7px 13px;
          font-size: 0.8rem;
          font-family: 'Outfit', sans-serif;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          gap: 5px;
        }
        .fbw-opt-btn.active {
          background: #b0b0b0;
          color: #0a0a0a;
          border: 1px solid #b0b0b0;
          font-weight: 700;
        }
        .fbw-opt-btn.inactive {
          background: transparent;
          color: #b8b8b8;
          border: 1px solid rgba(176,176,176,0.25);
        }

        /* GENDER FILTER */
        .fbw-gender-btn {
          padding: 7px 18px;
          border: none;
          border-radius: 2px;
          font-family: 'Outfit', sans-serif;
          font-size: 0.78rem;
          font-weight: 600;
          letter-spacing: 0.5px;
          cursor: pointer;
          transition: all 0.2s;
          min-width: 72px;
        }
        .fbw-gender-btn.active { background: #b0b0b0; color: #0a0a0a; }
        .fbw-gender-btn.inactive { background: transparent; color: #b8b8b8; }
      `}</style>

      <div className="fbw-wrapper">
        {/* HEADER */}
        <BrandMark />
        {step > 1 && step < 6 && <WizardProgress step={step} />}

        {/* CONTENT */}
        <div
          style={{
            flex: 1,
            padding: "8px 20px 40px",
            maxWidth: "600px",
            margin: "0 auto",
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          <ErrorBanner msg={error} onClose={() => setError(null)} />

          {/* ==================== STEP 1: GİRİŞ ==================== */}
          {step === 1 && (
            <div
              className="fbw-fade"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                minHeight: "45vh",
              }}
            >
              <div style={{ textAlign: "center", marginBottom: "36px" }}>
                <h2
                  style={{
                    fontFamily: "'Cormorant Garamond', serif",
                    fontStyle: "italic",
                    fontSize: "2rem",
                    fontWeight: 400,
                    color: "#ebebeb",
                    marginBottom: "8px",
                    lineHeight: 1.2,
                  }}
                >
                  Tarzınızı Keşfedin
                </h2>
                <p
                  style={{
                    color: "#787878",
                    fontSize: "0.85rem",
                    fontFamily: "'Outfit', sans-serif",
                  }}
                >
                  Hızlı randevu için bilgilerinizi giriniz.
                </p>
              </div>

              <form onSubmit={handleInfoSubmit} style={{ padding: "0 4px" }}>
                <div style={{ marginBottom: "12px" }}>
                  <input
                    className="fbw-input"
                    placeholder="Adınız"
                    value={userInfo.name}
                    onChange={(e) =>
                      setUserInfo({ ...userInfo, name: e.target.value })
                    }
                    required
                  />
                </div>
                <div style={{ marginBottom: "12px" }}>
                  <input
                    className="fbw-input"
                    placeholder="Soyadınız"
                    value={userInfo.surname}
                    onChange={(e) =>
                      setUserInfo({ ...userInfo, surname: e.target.value })
                    }
                    required
                  />
                </div>
                <div style={{ marginBottom: "28px", display: "flex", gap: 0 }}>
                  <div
                    style={{
                      background: "#b0b0b0",
                      color: "#0a0a0a",
                      fontWeight: 700,
                      fontSize: "0.9rem",
                      padding: "14px 14px",
                      borderRadius: "4px 0 0 4px",
                      display: "flex",
                      alignItems: "center",
                      fontFamily: "'Outfit', sans-serif",
                      flexShrink: 0,
                      letterSpacing: "0.5px",
                    }}
                  >
                    +90
                  </div>
                  <input
                    className="fbw-input"
                    style={{ borderRadius: "0 4px 4px 0", borderLeft: "none" }}
                    placeholder="5XX XXX XX XX"
                    type="tel"
                    maxLength={10}
                    value={userInfo.phone}
                    onChange={(e) =>
                      setUserInfo({
                        ...userInfo,
                        phone: e.target.value.replace(/\D/g, ""),
                      })
                    }
                    required
                  />
                </div>
                <LuxuryBtn type="submit" disabled={loading}>
                  {loading ? (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span
                        style={{
                          width: 14,
                          height: 14,
                          border: "2px solid rgba(0,0,0,0.3)",
                          borderTopColor: "#0a0a0a",
                          borderRadius: "50%",
                          animation: "spin 0.8s linear infinite",
                          display: "inline-block",
                        }}
                      />
                      İşleniyor...
                    </span>
                  ) : (
                    "Devam Et"
                  )}
                </LuxuryBtn>
              </form>
            </div>
          )}

          {/* ==================== STEP 2: UZMAN SEÇİMİ ==================== */}
          {step === 2 && (
            <div className="fbw-fade">
              <StepLabel num="1" label="Uzman Seçimi" />
              {staffList
                .filter((s) => !s.name.toLowerCase().includes("izinli"))
                .map((staff) => (
                  <StaffCard
                    key={staff.id}
                    staff={staff}
                    onClick={() => handleStaffSelect(staff)}
                  />
                ))}
              {staffList.length === 0 && (
                <p
                  style={{
                    color: "#787878",
                    textAlign: "center",
                    fontSize: "0.85rem",
                    padding: "40px 0",
                  }}
                >
                  Şu anda personel listesi yüklenemedi.
                </p>
              )}
            </div>
          )}

          {/* ==================== STEP 3: HİZMET & EKSTRALAR ==================== */}
          {step === 3 && (
            <div className="fbw-fade">
              <BackBtn onClick={() => setStep(2)} label="Uzman Seçimi" />
              <StepLabel num="2" label="Hizmet & Ekstralar" />

              {/* Cinsiyet Filtresi */}
              <div
                style={{
                  display: "flex",
                  background: "#1c1c1c",
                  border: "1px solid rgba(176,176,176,0.18)",
                  borderRadius: "4px",
                  padding: "4px",
                  gap: "2px",
                  width: "fit-content",
                  marginBottom: "16px",
                }}
              >
                {[
                  { val: "all", label: "Tümü" },
                  { val: "male", label: "Erkek" },
                  { val: "female", label: "Kadın" },
                ].map((opt) => (
                  <button
                    key={opt.val}
                    className={`fbw-gender-btn ${
                      genderFilter === opt.val ? "active" : "inactive"
                    }`}
                    onClick={() => setGenderFilter(opt.val)}
                  >
                    {opt.label}
                  </button>
                ))}
              </div>

              {isServicesLoading ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "60px 0",
                    color: "#787878",
                  }}
                >
                  <div
                    style={{
                      width: 28,
                      height: 28,
                      border: "2px solid rgba(176,176,176,0.15)",
                      borderTopColor: "#b0b0b0",
                      borderRadius: "50%",
                      animation: "spin 0.8s linear infinite",
                      margin: "0 auto 12px",
                    }}
                  />
                  <p
                    style={{
                      fontSize: "0.8rem",
                      fontFamily: "'Outfit', sans-serif",
                      margin: 0,
                    }}
                  >
                    Yükleniyor...
                  </p>
                </div>
              ) : (
                <>
                  {/* Ana Hizmetler */}
                  <div style={{ marginBottom: "16px" }}>
                    {filteredMainServices.map((service) => (
                      <ServiceCard
                        key={service.id}
                        service={service}
                        selected={selectedService?.id === service.id}
                        onClick={() => handleServiceSelect(service)}
                      />
                    ))}
                    {filteredMainServices.length === 0 && (
                      <p
                        style={{
                          color: "#787878",
                          fontSize: "0.83rem",
                          textAlign: "center",
                          padding: "20px 0",
                          fontFamily: "'Outfit', sans-serif",
                        }}
                      >
                        Bu kategoride hizmet bulunamadı.
                      </p>
                    )}
                  </div>

                  {/* Opsiyonel Ekstralar */}
                  {selectedService && optionalServices.length > 0 && (
                    <div
                      style={{
                        border: "1px dashed rgba(176,176,176,0.2)",
                        borderRadius: "4px",
                        background: "#1c1c1c",
                        padding: "14px 16px",
                        marginBottom: "16px",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "0.65rem",
                          letterSpacing: "1.5px",
                          textTransform: "uppercase",
                          color: "#787878",
                          fontFamily: "'Outfit', sans-serif",
                          marginBottom: "12px",
                          margin: "0 0 12px",
                        }}
                      >
                        Ekstra İşlemler (İsteğe Bağlı)
                      </p>
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "8px",
                        }}
                      >
                        {optionalServices.map((opt) => {
                          const isSel = selectedOptionalServices.some(
                            (s) => s.id === opt.id
                          );
                          return (
                            <button
                              key={opt.id}
                              className={`fbw-opt-btn ${
                                isSel ? "active" : "inactive"
                              }`}
                              onClick={() => handleToggleOptionalService(opt)}
                            >
                              {isSel && <FiCheck size={12} />}
                              {opt.name}
                              <span style={{ opacity: 0.5, marginLeft: "2px" }}>
                                ({opt.duration}dk)
                              </span>
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  <div ref={nextButtonRef}>
                    <LuxuryBtn
                      onClick={handleProceedToTime}
                      disabled={!selectedService}
                    >
                      Tarih ve Saat Seçimine Geç
                    </LuxuryBtn>
                  </div>
                </>
              )}
            </div>
          )}

          {/* ==================== STEP 4: TARİH & SAAT ==================== */}
          {step === 4 && (
            <div className="fbw-fade">
              <BackBtn onClick={() => setStep(3)} label="Hizmet Seçimi" />
              <StepLabel num="3" label="Tarih ve Saat" />

              {/* Takvim */}
              <div className="fbw-cal" style={{ marginBottom: "20px" }}>
                <Calendar
                  onChange={setSelectedDate}
                  value={selectedDate}
                  tileDisabled={isDayDisabled}
                  maxDate={maxDateLimit}
                  prev2Label={null}
                  next2Label={null}
                />
              </div>

              {/* Seçili Tarih Label */}
              <p
                style={{
                  textAlign: "center",
                  fontSize: "0.72rem",
                  letterSpacing: "2px",
                  textTransform: "uppercase",
                  color: "#787878",
                  fontFamily: "'Outfit', sans-serif",
                  marginBottom: "18px",
                }}
              >
                {selectedDate.toLocaleDateString("tr-TR", {
                  day: "numeric",
                  month: "long",
                  weekday: "long",
                })}
              </p>

              {/* Saat Slotları */}
              {isTimeLoading ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "32px 0",
                    color: "#787878",
                  }}
                >
                  <div
                    style={{
                      width: 22,
                      height: 22,
                      border: "2px solid rgba(176,176,176,0.15)",
                      borderTopColor: "#b0b0b0",
                      borderRadius: "50%",
                      animation: "spin 0.8s linear infinite",
                      margin: "0 auto 10px",
                    }}
                  />
                  <p
                    style={{
                      fontSize: "0.78rem",
                      fontFamily: "'Outfit', sans-serif",
                      margin: 0,
                    }}
                  >
                    Müsaitlik kontrol ediliyor...
                  </p>
                </div>
              ) : timeSlots.length === 0 ? (
                <p
                  style={{
                    textAlign: "center",
                    color: "#787878",
                    fontSize: "0.83rem",
                    fontFamily: "'Outfit', sans-serif",
                    padding: "24px 0",
                  }}
                >
                  Bu tarih için uygun saat bulunamadı.
                </p>
              ) : (
                <div className="fbw-slot-grid">
                  {timeSlots.map((slot, index) => (
                    <TimeSlot
                      key={`${slot.time}-${index}`}
                      slot={slot}
                      selected={selectedTime === slot.time}
                      onClick={() => setSelectedTime(slot.time)}
                    />
                  ))}
                </div>
              )}

              <LuxuryBtn onClick={() => setStep(5)} disabled={!selectedTime}>
                Özet ve Onay
              </LuxuryBtn>
            </div>
          )}

          {/* ==================== STEP 5: ONAY ==================== */}
          {step === 5 && (
            <div className="fbw-fade">
              <BackBtn onClick={() => setStep(4)} label="Saat Seçimi" />
              <StepLabel num="4" label="Son Kontrol" />

              {/* Özet Kart */}
              <div
                style={{
                  background: "#1c1c1c",
                  border: "1px solid rgba(176,176,176,0.12)",
                  borderLeft: "3px solid #b0b0b0",
                  borderRadius: "4px",
                  padding: "20px",
                  marginBottom: "20px",
                }}
              >
                {/* Personel */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "14px",
                    paddingBottom: "16px",
                    borderBottom: "1px solid rgba(176,176,176,0.1)",
                    marginBottom: "16px",
                  }}
                >
                  {selectedStaff?.picture ? (
                    <img
                      src={selectedStaff.picture}
                      alt=""
                      style={{
                        width: 48,
                        height: 48,
                        borderRadius: "50%",
                        border: "1px solid #b0b0b0",
                        objectFit: "cover",
                        flexShrink: 0,
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: 48,
                        height: 48,
                        borderRadius: "50%",
                        border: "1px solid #b0b0b0",
                        background: "rgba(176,176,176,0.05)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#b0b0b0",
                        fontWeight: 700,
                        fontSize: "1rem",
                        fontFamily: "'Outfit', sans-serif",
                        flexShrink: 0,
                      }}
                    >
                      {getInitials(selectedStaff?.name || "")}
                    </div>
                  )}
                  <div>
                    <div
                      style={{
                        color: "#ebebeb",
                        fontWeight: 600,
                        fontFamily: "'Outfit', sans-serif",
                      }}
                    >
                      {selectedStaff?.name} {selectedStaff?.surname}
                    </div>
                    <div
                      style={{
                        color: "#787878",
                        fontSize: "0.73rem",
                        fontFamily: "'Outfit', sans-serif",
                      }}
                    >
                      Seçilen Uzman
                    </div>
                  </div>
                </div>

                {/* Hizmet */}
                <div style={{ marginBottom: "14px" }}>
                  <div
                    style={{
                      fontSize: "0.62rem",
                      letterSpacing: "1.5px",
                      textTransform: "uppercase",
                      color: "#787878",
                      fontFamily: "'Outfit', sans-serif",
                      marginBottom: "5px",
                    }}
                  >
                    Hizmet
                  </div>
                  <div
                    style={{
                      color: "#ebebeb",
                      fontWeight: 600,
                      fontFamily: "'Outfit', sans-serif",
                      fontSize: "0.97rem",
                    }}
                  >
                    {selectedService?.name}
                  </div>
                  {selectedOptionalServices.length > 0 && (
                    <div
                      style={{
                        marginTop: "6px",
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "6px",
                      }}
                    >
                      {selectedOptionalServices.map((s) => (
                        <span
                          key={s.id}
                          style={{
                            color: "#787878",
                            fontSize: "0.78rem",
                            fontFamily: "'Outfit', sans-serif",
                            background: "rgba(176,176,176,0.06)",
                            border: "1px solid rgba(176,176,176,0.12)",
                            borderRadius: "3px",
                            padding: "3px 8px",
                          }}
                        >
                          + {s.name}
                        </span>
                      ))}
                    </div>
                  )}
                </div>

                {/* Tarih & Saat */}
                <div style={{ marginBottom: "16px" }}>
                  <div
                    style={{
                      fontSize: "0.62rem",
                      letterSpacing: "1.5px",
                      textTransform: "uppercase",
                      color: "#787878",
                      fontFamily: "'Outfit', sans-serif",
                      marginBottom: "5px",
                    }}
                  >
                    Zaman
                  </div>
                  <div
                    style={{
                      color: "#ebebeb",
                      fontFamily: "'Outfit', sans-serif",
                      fontWeight: 600,
                      fontSize: "1.15rem",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <FiCalendar size={15} style={{ color: "#b0b0b0" }} />
                    {formatDate(selectedDate)}
                    <span style={{ color: "#484848", margin: "0 2px" }}>|</span>
                    <FiClock size={15} style={{ color: "#b0b0b0" }} />
                    {selectedTime}
                  </div>
                </div>

                {/* Not Alanı */}
                <textarea
                  className="fbw-textarea"
                  rows={2}
                  placeholder="Özel bir notunuz var mı? (İsteğe bağlı)"
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />
              </div>

              <LuxuryBtn onClick={handleConfirmBooking} disabled={isSubmitting}>
                {isSubmitting ? (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <span
                      style={{
                        width: 14,
                        height: 14,
                        border: "2px solid rgba(0,0,0,0.3)",
                        borderTopColor: "#0a0a0a",
                        borderRadius: "50%",
                        animation: "spin 0.8s linear infinite",
                        display: "inline-block",
                      }}
                    />
                    İşleniyor...
                  </span>
                ) : (
                  "Randevuyu Onayla"
                )}
              </LuxuryBtn>
            </div>
          )}

          {/* ==================== STEP 6: TEŞEKKÜR ==================== */}
          {step === 6 && (
            <div
              className="fbw-fade"
              style={{
                textAlign: "center",
                paddingTop: "48px",
                paddingBottom: "24px",
              }}
            >
              {/* İkon */}
              <div style={{ marginBottom: "24px" }}>
                <div
                  style={{
                    width: 80,
                    height: 80,
                    borderRadius: "50%",
                    background: "rgba(176,176,176,0.08)",
                    border: "1px solid rgba(176,176,176,0.2)",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <FiCheckCircle size={38} style={{ color: "#b0b0b0" }} />
                </div>
              </div>

              <h2
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontStyle: "italic",
                  fontSize: "2.2rem",
                  fontWeight: 600,
                  color: "#ebebeb",
                  letterSpacing: "2px",
                  marginBottom: "8px",
                }}
              >
                Teşekkürler
              </h2>
              <p
                style={{
                  color: "#787878",
                  fontSize: "0.88rem",
                  fontFamily: "'Outfit', sans-serif",
                  marginBottom: "40px",
                }}
              >
                Randevunuz başarıyla oluşturulmuştur.
              </p>

              {/* Link Kutusu */}
              <div
                style={{
                  background: "#1c1c1c",
                  border: "1px solid rgba(176,176,176,0.1)",
                  borderRadius: "6px",
                  padding: "16px",
                  textAlign: "left",
                }}
              >
                <div
                  style={{ display: "flex", gap: "10px", marginBottom: "14px" }}
                >
                  <FiInfo
                    size={16}
                    style={{
                      color: "#b0b0b0",
                      flexShrink: 0,
                      marginTop: "1px",
                    }}
                  />
                  <p
                    style={{
                      color: "#787878",
                      fontSize: "0.8rem",
                      fontFamily: "'Outfit', sans-serif",
                      lineHeight: 1.55,
                      margin: 0,
                    }}
                  >
                    Randevularınızı takip etmek veya iptal etmek için panelinizi
                    tarayıcıdan açabilirsiniz.
                  </p>
                </div>
                <div
                  style={{
                    background: "#0a0a0a",
                    border: "1px solid rgba(176,176,176,0.1)",
                    borderRadius: "4px",
                    padding: "10px 14px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <span
                    style={{
                      color: "#b0b0b0",
                      fontFamily: "monospace",
                      fontSize: "0.8rem",
                      flex: 1,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    mudamukuafor.com
                  </span>
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(
                        "https://mudamukuafor.com/customer/dashboard"
                      );
                      alert("Link Kopyalandı");
                    }}
                    style={{
                      background: "none",
                      border: "1px solid rgba(176,176,176,0.3)",
                      borderRadius: "4px",
                      color: "#b0b0b0",
                      cursor: "pointer",
                      padding: "5px 9px",
                      display: "flex",
                      alignItems: "center",
                      transition: "all 0.2s",
                      flexShrink: 0,
                    }}
                  >
                    <FiCopy size={14} />
                  </button>
                </div>
              </div>

              <button
                onClick={() => window.location.reload()}
                style={{
                  marginTop: "28px",
                  background: "none",
                  border: "none",
                  color: "#b0b0b0",
                  cursor: "pointer",
                  fontFamily: "'Outfit', sans-serif",
                  fontSize: "0.82rem",
                  letterSpacing: "1.5px",
                  textTransform: "uppercase",
                  fontWeight: 600,
                  textDecoration: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "8px",
                  transition: "color 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = "#ebebeb";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = "#b0b0b0";
                }}
              >
                <FiArrowRight size={14} />
                Yeni Randevu Al
              </button>
            </div>
          )}
        </div>

        {/* FOOTER */}
        <div
          style={{
            textAlign: "center",
            padding: "20px 16px 28px",
            marginTop: "auto",
          }}
        >
          <p
            style={{
              color: "#484848",
              fontSize: "0.68rem",
              fontFamily: "'Outfit', sans-serif",
              margin: "0 0 4px",
            }}
          >
            Powered By{" "}
            <a
              href="https://www.vireliosoft.com"
              target="_blank"
              rel="noreferrer"
              style={{ color: "#787878", textDecoration: "none" }}
            >
              Vireliosoft
            </a>{" "}
            /{" "}
            <a
              href="https://www.randevupp.com"
              target="_blank"
              rel="noreferrer"
              style={{ color: "#787878", textDecoration: "none" }}
            >
              RandevUpp
            </a>
          </p>
          <span
            style={{
              color: "#333333",
              fontSize: "0.63rem",
              fontFamily: "'Outfit', sans-serif",
            }}
          >
            © 2026 Mudamu Kuafor
          </span>
        </div>
      </div>

      {/* Spin animasyonu */}
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </>
  );
};

export default FastBooking;
